// Copyright © 2025 The Things Industries B.V.

import React from 'react'
import { Route, Routes } from 'react-router-dom'

import Breadcrumb from '@ttn-lw/components/breadcrumbs/breadcrumb'
import { useBreadcrumbs } from '@ttn-lw/components/breadcrumbs/context'

import GenericNotFound from '@ttn-lw/lib/components/full-view-error/not-found'
import ValidateRouteParam from '@ttn-lw/lib/components/validate-route-param'

import Require from '@console/lib/components/require'

import LabelsList from '@console/views/labels-list/index.tti'
import Label from '@console/views/label/index.tti'

import sharedMessages from '@ttn-lw/lib/shared-messages'
import { pathId as pathIdRegexp } from '@ttn-lw/lib/regexp'

import { mayViewLabels } from '@console/lib/feature-checks'

const Labels = () => {
  useBreadcrumbs('overview.labels', <Breadcrumb path="/labels" content={sharedMessages.labels} />)

  return (
    <Require featureCheck={mayViewLabels} otherwise={{ redirect: '/' }}>
      <Routes>
        <Route index Component={LabelsList} />
        <Route
          path=":labelId"
          element={<ValidateRouteParam check={{ labelId: pathIdRegexp }} Component={Label} />}
        />
        <Route path="*" Component={GenericNotFound} />
      </Routes>
    </Require>
  )
}

export default Labels
